








































import TransitionMixins from '@/mixins/TransitionMixins';
import { Component, Mixins, ModelSync, Prop } from 'vue-property-decorator';
import { mapState } from 'vuex';
import QListItemExpand from '../QListItemExpand.vue';

@Component({
  components: {
    QListItemExpand,
  },
  computed: {
    ...mapState({
      loading: 'loading',
    }),
    ...mapState('Business', {
      searchOptions: 'searchOptions',
    }),
  },
})
export default class BusinessSelect extends Mixins(TransitionMixins) {
  @ModelSync('selected', 'change') selectedBusinessOid!: string;

  @Prop() readonly businessOid!: string;

  search = '';

  items = [];

  searchOptions!: {
    query: string;
    itemsPerPage: number;
  };

  get options() {
    return this.searchOptions;
  }

  set options(value) {
    this.$store.commit('Business/SET_SEARCH_OPTIONS', value);
  }

  get isSelected() {
    return !!this.selectedBusinessOid;
  }

  async setSelection(item) {
    if (item.object_id !== this.selectedBusinessOid) {
      this.$emit('change', item.object_id);
    } else {
      this.$emit('change', '');
    }
  }

  handleFetchJobList(query, page, itemsPerPage) {
    if (query.length > 2) {
      this.selectedBusinessOid = '';

      return this.$store.dispatch('Business/fetchList', {
        params: {
          search_name: query,
          page: page,
          per_page: itemsPerPage === -1 ? 10 : itemsPerPage,
          sort: '-updated_at',
        },
      });
    }
    if (!query.length) {
      return this.$store.dispatch('Business/fetchList', {
        params: {
          page: page,
          per_page: itemsPerPage === -1 ? 10 : itemsPerPage,
          sort: '-updated_at',
        },
      });
    }
    return {
      items: [],
      total: 0,
    };
  }

  closeQuery() {
    this.options.query = '';
    this.$emit('change', '');
  }
}
